<template>
	<a-modal :title="'发票明细'" :visible="isVisible" @ok="handleOk" @cancel="closeModal" width="70%" :destroyOnClose="true">
		<div><a-button  type="primary" size="small"  @click="exportInvoiceOrder" >导出</a-button></div>
		<a-table :columns="columnData" :dataSource="dataSource" bordered size="middle" :pagination="false">
			<template slot="marketOperationOrderSn" slot-scope="text, record,index">
				<a @click="detail(record)">{{record.marketOperationOrderSn}}</a>
			</template>
			<template slot="format1"  slot-scope="text, record,index" v-if="record.postLink">
				<a-tooltip placement="topLeft" :title="record.postLink">{{ record.postLink.replace(/(.{5})(.*)/, '$1...') }}</a-tooltip>
			</template>
			<template slot="format2"  slot-scope="text, record,index" v-if="record.executiveCompany">
				<a-tooltip placement="topLeft" :title="record.executiveCompany">{{ record.executiveCompany.replace(/(.{5})(.*)/, '$1...') }}</a-tooltip>
			</template>
			<template slot="format3"  slot-scope="text, record,index" v-if="record.remark">
				<a-tooltip placement="topLeft" :title="record.remark">{{ record.remark.replace(/(.{5})(.*)/, '$1...') }}</a-tooltip>
			</template>
			<template slot="thisInvoicedAmount" slot-scope="text, record,index">
				<span v-if="onlyRead">{{ record.thisInvoicedAmount }}</span>
				<editable-cell v-else :ref="'editable'+index" :text="text" @change="onCellChange(record, 'thisInvoicedAmount', $event,index)" />
			</template>
		</a-table>
	</a-modal>
</template>

<script>
import CustomPage from '@/views/common/CustomPage';
import EditableCell from '@/components/editableCell/editableCell';

const table = {
	searchForm: {
		name: ''
	},
	url: 'supplier',
	columnData: [
		{
			title: '平台',
			dataIndex: 'platformType_text',
		},
		{
			title: '市场运营表订单编号',
			dataIndex: 'marketOperationOrderSn',
			scopedSlots: { customRender: 'marketOperationOrderSn' }
		},
		{
			title: '账号订单编号',
			dataIndex: 'accountOrderSn'
		},
		{
			title: '执行日期',
			dataIndex: 'executionDateStr'
		},
		{
			title: '账号名称',
			dataIndex: 'accountName'
		},
		{
			title: '内容类型',
			dataIndex: 'contentType',
		},
		{
			title: '项目名称',
			dataIndex: 'projectName'
		},
		{
			title: '发布链接',
			dataIndex: 'postLink',
			scopedSlots: { customRender: 'format1' },
			width: 100
		},
		{
			title: '报价',
			dataIndex: 'price'
		},
		{
			title: '结算方式',
			dataIndex: 'settlementType_text',
		},
		{
			title: '接单人',
			dataIndex: 'orderRecipientName'
		},
		{
			title: '下单人',
			dataIndex: 'orderPersonName'
		},
		{
			title: '执行公司',
			dataIndex: 'executiveCompany',
			scopedSlots: { customRender: 'format2' },
			width: 100
		},
		{
			title: '备注',
			dataIndex: 'remark',
			scopedSlots: { customRender: 'format3' },
			width: 100
		}
	]
};
export default {
	components: {
		CustomPage,
		EditableCell
	},
	props: {
		isVisible: {
			type: Boolean
		},
		customerId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			...table,
			onlyRead: false,
			form: this.$form.createForm(this),
			labelCol: {
				xs: { span: 24 },
				sm: { span: 6 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 16 }
			},
			dataSource: [],
			invoiceId: null,
			text:null
		};
	},
	mounted() {
	},
	methods: {
		exportInvoiceOrder(){
			this.$download('/invoiceDetail/exportInvoiceOrder', { invoiceId: this.invoiceId }, '发票订单信息.xlsx').then();
		},
		detail(record){
			this.$get("order/getUuidByMarketOperationOrderSn", {marketOperationOrderSn: record.marketOperationOrderSn}).then(res => {
				if(!res.data){
					this.$message.warn('找不到对应订单');
					return;
				}
			    this.closeModal()
			    this.$parent.onClose();
			    this.$router.push({
			        path:'/order/orderDetail',
			        query: {
			    		uuid: String(res.data.uuid),
					}
			    })
			});

		},
		onlyReadOrder(invoiceId){
			this.invoiceId = invoiceId;
			this.onlyRead = true;
			this.$get('invoiceDetail/findByInvoiceId',{ invoiceId: invoiceId }).then(res => {
				this.dataSource = res.data;
			})
		},
		getOrderArr(item,title){
			this.onlyRead = false;
			let url = title == '编辑发票' || title == '发票详情' ? "invoiceDetail/showDetailOrder" : "invoiceDetail/invoiceDetailOrder"
			if (title == '发票详情') {
				this.onlyRead = true;
			}
			this.$get(url,{customerId: this.customerId}).then(res => {
				let result = res.data;
				if (item) {
					item.forEach(key => {
						const data = result;
						const target = data.find(e => e.orderId === key.orderId);
						if (target) {
							target['thisInvoicedAmount'] = key['thisInvoicedAmount'].toString();
							result = data;
						}
					})
				}
				this.dataSource = result;
			})
		},
		onCellChange(key, dataIndex, value, index) {
			const data = [...this.dataSource];
			const target = data.find(item => item.orderId === key.orderId);
			let temp = Number(key.finalPrice) - Number(key.totalInvoicedAmount);
			if (target) {
				// target[dataIndex] = Number(value) > temp ? temp.toString() : value;
				target[dataIndex] = value;
				this.$refs['editable'+index].valueChange(target[dataIndex])
				this.dataSource = data;
			}
		},
		closeModal() {
			this.dataSource = [];
			this.invoiceId = null;
			this.$emit('closeModal');
		},
		handleOk() {
			let that = this;
			let result = {
				total: 0,
				invoiceDetail:[]
			}
			this.dataSource.forEach(item =>{
				if (item.thisInvoicedAmount) {
					result.total += Number(item.thisInvoicedAmount)
					let temp = {
						orderId: item.orderId,
						thisInvoicedAmount: item.thisInvoicedAmount
					}
					result.invoiceDetail.push(temp)
				}
			})
			// return
			this.closeModal()
			this.$emit('handleOk', result)
		},
	}
};
</script>

<style lang="less" scoped>
p {
	margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/connection/invoice/addInvoice/addInvoiceDetail.vue